import type { SVGProps } from 'react';
export const SvgReload = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={40}
		height={40}
		fill="none"
		viewBox="0 0 40 40"
		{...props}
	>
		<rect width={39} height={39} x={0.5} y={0.5} fill="#fff" rx={19.5} />
		<rect width={39} height={39} x={0.5} y={0.5} stroke="#D6D6D6" rx={19.5} />
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M17.662 13.997c.7-.21 1.47-.35 2.338-.35 3.864 0 7 3.136 7 7s-3.136 7-7 7-7-3.136-7-7c0-1.442.434-2.772 1.176-3.892"
		/>
		<path
			stroke="#101010"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="m16.668 14.193 2.324-2.674M16.668 14.192l2.716 1.988"
		/>
	</svg>
);
